export const TransferSkeleton = () => (
  <div data-testid="transfer-skeleton" className="animate-pulse space-y-6">
    <div className="mx-auto h-20 w-20 rounded-full bg-gray-200 dark:bg-gray-700" />
    <div className="space-y-3">
      <div className="mx-auto h-7 w-3/4 rounded bg-gray-200 dark:bg-gray-700" />
      <div className="h-4 w-full rounded bg-gray-200 dark:bg-gray-700" />
      <div className="h-4 w-5/6 rounded bg-gray-200 dark:bg-gray-700" />
    </div>
    <div className="space-y-2">
      <div className="h-4 w-full rounded bg-gray-200 dark:bg-gray-700" />
      <div className="h-4 w-4/5 rounded bg-gray-200 dark:bg-gray-700" />
      <div className="h-4 w-3/4 rounded bg-gray-200 dark:bg-gray-700" />
    </div>
    <div className="flex gap-3">
      <div className="h-10 flex-1 rounded-lg bg-gray-200 dark:bg-gray-700" />
      <div className="h-10 flex-1 rounded-lg bg-gray-200 dark:bg-gray-700" />
    </div>
  </div>
);
